import { cx } from 'cvb';
import PropTypes from 'prop-types';
import { useConnectTab } from '../hooks/useConnectTab';
import { ConnectTabStyles } from './style';

const ConnectTab = ({ tabData, variant, digitalData }) => {
  const hookData = useConnectTab({ tabData, variant, digitalData });

  if (!hookData.shouldRender) {
    return null;
  }

  const { processedTabData, handleSelectedTab, leftTabId, rightTabId } = hookData;

  const { leftTab, rightTab } = processedTabData;

  // BEM class generators for v2
  const getTabHeaderBEMClasses = (isActive) => {
    const baseClasses = ['connect-tab__header', `connect-tab__header--${variant}`];

    if (isActive) {
      baseClasses.push('connect-tab__header--active', `connect-tab__header--active-${variant}`);
    }

    return baseClasses.join(' ');
  };

  const getTabContentBEMClasses = (isActive) => {
    const baseClasses = ['connect-tab__content'];

    if (!isActive) {
      baseClasses.push('connect-tab__content--hidden');
    }

    return baseClasses.join(' ');
  };

  return (
    <div className="connect-tab" data-testid="connect-tab">
      <div
        className={cx('connect-tab__headers', `connect-tab__headers--${variant}`)}
        role="tablist"
        aria-label="Product connection tabs"
      >
        <button
          className={getTabHeaderBEMClasses(leftTab.isActive)}
          onClick={() => handleSelectedTab(0)}
          type="button"
          id={leftTabId}
          role="tab"
          aria-selected={leftTab.isActive}
          aria-controls={`${leftTabId}-panel`}
          data-testid="connect-tab__left-button"
        >
          <span className="connect-tab__header-text">{leftTab.title}</span>
        </button>
        <button
          className={getTabHeaderBEMClasses(rightTab.isActive)}
          type="button"
          onClick={() => handleSelectedTab(1)}
          id={rightTabId}
          role="tab"
          aria-selected={rightTab.isActive}
          aria-controls={`${rightTabId}-panel`}
          data-testid="connect-tab__right-button"
        >
          <span className="connect-tab__header-text">{rightTab.title}</span>
        </button>
      </div>

      <div
        className={getTabContentBEMClasses(leftTab.isActive)}
        id={`${leftTabId}-panel`}
        role="tabpanel"
        aria-labelledby={leftTabId}
        data-testid="connect-tab__left-content"
      >
        {leftTab.content()}
      </div>

      <div
        className={getTabContentBEMClasses(rightTab.isActive)}
        id={`${rightTabId}-panel`}
        role="tabpanel"
        aria-labelledby={rightTabId}
        data-testid="connect-tab__right-content"
      >
        {rightTab.content()}
      </div>

      <style jsx>{ConnectTabStyles}</style>
    </div>
  );
};

ConnectTab.defaultProps = {
  tabData: [],
  variant: 'primary',
};

ConnectTab.propTypes = {
  tabData: PropTypes.arrayOf(PropTypes.object),
  variant: PropTypes.oneOf(['primary', 'secondary', 'rebranding']),
  digitalData: PropTypes.object.isRequired,
};

export { ConnectTab };
export default ConnectTab;
